import { useMutation, useQuery } from "@tanstack/react-query";
import { apiFetch } from "./apiClient";

/** Účet přihlášeného uživatele — `/admin/api/v1/me` (isAuthenticated). */
export interface MeProfile {
  id: string;
  username: string;
  displayName: string | null;
  email: string | null;
  roles: string[];
  authSource?: string;
  externalIdentifier?: string | null;
  bootstrap?: boolean;
  mustChangePassword?: boolean;
}

export function useMe() {
  return useQuery({ queryKey: ["me"], queryFn: () => apiFetch<MeProfile>("/admin/api/v1/me") });
}

export function useChangeOwnPassword() {
  return useMutation({
    mutationFn: ({ currentPassword, newPassword }: { currentPassword: string; newPassword: string }) =>
      apiFetch<void>("/admin/api/v1/me/password", { method: "POST", json: { currentPassword, newPassword } }),
  });
}
